import React, {useEffect, useState, useContext, useMemo} from "react";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import { TabView, TabPanel } from 'primereact/tabview';
import NewClaimManualForm from "@/Components/Forms/NewClaimManualForm";
import NewClaimOCRForm from "@/Components/Forms/NewClaimOCRForm";
import NewClaimXlsForm from "@/Components/Forms/NewClaimXlsForm";
import styled from "styled-components";
import NewClaimDACBXlsForm from "@/Components/Forms/NewClaimDACBXlsForm";
import {useAuthUser} from "@/Hooks/useAuthUser";

const PageWrap = styled.div`
    .main-content {
        min-height: 60vh;
    }
`;

/**
 * New claim page
 */
const NewClaimPage = () => {
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const authUser = useAuthUser();
    const isDACBUser = useMemo(() => authUser?.client?.name === 'DACB', [authUser?.client?.name]);

    useEffect(() => {
        document.title = 'New claim' + ' · ' + document.title;
    }, []);

    return (
        <PageLayout>
            <PageWrap>
                <TabView activeIndex={activeTabIndex} onTabChange={(e) => setActiveTabIndex(e.index)}>
                    <TabPanel header="Automated parsing">
                        <NewClaimOCRForm />
                    </TabPanel>

                    <TabPanel header="Read spreadsheet">
                        <NewClaimXlsForm />
                    </TabPanel>

                    <TabPanel header="Manual input">
                        <NewClaimManualForm />
                    </TabPanel>

                    <TabPanel header="API">
                        <p>Please click the following link to view our Swagger documentation:</p>
                        <p>
                            <a className="text-highlight" target="_blank" href={import.meta.env.VITE_API_URL + 'documentation'}>
                                <span>{import.meta.env.VITE_API_URL + 'documentation'}</span>
                            </a>
                        </p>
                    </TabPanel>


                    {isDACBUser && (
                        <TabPanel header="DACB spreadsheet">
                            <NewClaimDACBXlsForm />
                        </TabPanel>
                    )}
                </TabView>
            </PageWrap>
        </PageLayout>
    );
};

export default NewClaimPage;